var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationRings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3545 21.7704C40.3818 25.7978 40.3818 32.3273 36.3545 36.3546C32.3272 40.3819 25.7977 40.3819 21.7704 36.3546C17.7432 32.3273 17.7432 25.7978 21.7704 21.7704C25.7977 17.7432 32.3272 17.7432 36.3545 21.7704Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2295 21.7704C27.2568 25.7978 27.2568 32.3273 23.2295 36.3546C19.2022 40.3819 12.6727 40.3819 8.64546 36.3546C4.61818 32.3273 4.61818 25.7978 8.64546 21.7704C12.6727 17.7432 19.2022 17.7432 23.2295 21.7704Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.125 6.91312C28.125 7.73437 27.7706 8.52375 27.1387 9.1125L22.9931 12.9825C22.7156 13.2412 22.2844 13.2412 22.005 12.9825L17.8613 9.11437C17.2294 8.52375 16.875 7.73437 16.875 6.91312C16.875 5.16563 18.2906 3.75 20.0381 3.75H24.9619C26.7094 3.75 28.125 5.16563 28.125 6.91312Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRings);
export default __webpack_public_path__ + "static/media/navigation-rings.325e3941.svg";
export { ForwardRef as ReactComponent };